import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="inicio" className="relative w-full min-h-screen md:h-screen md:min-h-[760px] flex items-center justify-center overflow-hidden" data-id="element-270" data-mp="ejwl1drxcj8d">
      <div className="absolute inset-0 bg-forest/60 z-10" data-id="element-271" data-mp="9lbkfd8rfxje" />
      <motion.img initial={{
      scale: 1.05
    }} animate={{
      scale: 1
    }} transition={{
      duration: 10,
      ease: 'easeOut'
    }} src="https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?auto=format&fit=crop&q=80" alt="Bosque aéreo" className="absolute inset-0 w-full h-full object-cover" data-id="element-272" data-mp="4mi2n8mfxkdf" />

      <div className="relative z-20 text-center px-4 max-w-5xl mx-auto mt-16 pb-40 md:pb-48" data-id="element-273" data-mp="nczrh245jvti">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="block text-bone/90 uppercase tracking-[0.2em] text-xs md:text-sm font-semibold mb-6 md:mb-8" data-id="element-274" data-mp="3d1scj2wkntvr">
          Programa TEFOS · Territorios Forestales Sostenibles
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl lg:text-8xl font-serif text-bone leading-[1.1] mb-8" data-id="element-275" data-mp="3e9607lvoxtee">
          Tejiendo territorio, <br className="hidden md:block" data-id="element-276" data-mp="2vievixmner6c" /> bosque y
          comunidad
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="mb-10 md:mb-12 text-lg md:text-2xl text-bone/90 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-277" data-mp="2hina4btsy8ib">
          Un esfuerzo conjunto para la conservación, el ordenamiento territorial
          y el bienestar de las comunidades locales en Colombia
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 md:gap-x-16" data-id="element-278" data-mp="1b0vx1kt7peg5">
          <img src="https://cdn.magicpatterns.com/uploads/1554FSqSpXimr2tT95ZMpx/ukgov.png" alt="UK Government" className="h-12 md:h-16 w-auto object-contain" data-id="element-279" data-mp="x3h0zx8ge8f7" />
          <img src="https://cdn.magicpatterns.com/uploads/5eEj32p5yeWcGYPMSkLfNY/logobe.png" alt="Embajada" className="h-12 md:h-16 w-auto object-contain" data-id="element-280" data-mp="1x9b590wn91ck" />
          <img src="https://cdn.magicpatterns.com/uploads/vVTk2RNb3FtfY1h5LMmmTn/lbicentenari.png" alt="Bicentenario 200" className="h-16 md:h-24 w-auto object-contain" data-id="element-281" data-mp="269zfdkix2hk6" />
          <img src="https://cdn.magicpatterns.com/uploads/p9ChSiysCyRLAY9MS6xLVN/bancotefos.png" alt="Grupo Banco Mundial" className="h-12 md:h-16 w-auto object-contain" data-id="element-282" data-mp="2g0c13g2gwgrw" />
        </motion.div>
      </div>
    </section>;
}